import { useParams } from 'react-router-dom';

export function useOrderIdParam(): string {
	const params = useParams<'orderId'>();
	if (!params.orderId) {
		throw new Error('orderId are required in the URL parameters');
	}
	return (params as { orderId: string }).orderId;
}
